import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'HomePage',
        component: () => import('../views/Home.vue')
    },
    {
        path: '/exam',
        name: 'Exam',
        component: () => import('../views/Exam.vue')
    },
    {
        path: '/exam-confirm',
        name: 'ExamConfirm',
        component: () => import('../views/ExamConfirm.vue')
    },
    {
        path: '/cate',
        name: 'Cate',
        component: () => import('../views/Cate.vue')
    },
    {
        path: '/week',
        name: 'Week',
        component: () => import('../views/Week.vue')
    },
    {
        path: '/Specialized',
        name: 'Specialized',
        component: () => import('../views/Specialized.vue')
    },
    {
        path: '/Iconpractice',
        name: 'Iconpractice',
        component: () => import('../views/IconPractice.vue')
    },
    {
        path: '/Examresult',
        name: 'Examresult',
        component: () => import('../views/ExamResult.vue')
    },
    {
        path: '/Sanli',
        name: 'Sanli',
        component: () => import('../views/Sanli.vue')
    },
    {
        path: '/Myerror',
        name: 'Myerror',
        component: () => import('../views/Myerror.vue')
    },
    {
        path: '/studyrecord',
        name: 'StudyRecord',
        component: () => import('../views/StudyRecord.vue')
    },
    {
        path: '/PracticeExamResult',
        name: 'PracticeExamResult',
        component: () => import('../views/PracticeExamResult.vue')
    },
    {
        path: '/Foundation',
        name: 'Foundation',
        component: () => import('../views/Foundation.vue')
    },
    {
        path: '/Sutong',
        name: 'Sutong',
        component: () => import('../views/Sutong.vue')
    },
    {
        path: '/HightTest',
        name: 'HightTest',
        component: () => import('../views/HightTest.vue')
    },
    {
        path: '/systemmsg',
        name: 'Systemmsg',
        component: () => import('../views/Systemmsg.vue')
    },
    {
        path: '/ZijianJiaoxue',
        name: 'ZijianJiaoxue',
        component: () => import('../views/ZijianJiaoxue.vue')
    },
    {
        path: '/teaching-guide',
        name: 'TeachingGuide',
        component: () => import('../views/TeachingGuide.vue')
    }
]

const router = new VueRouter({
    mode: 'hash', // 建议用 hash，对 Win7 老浏览器和打包后运行更友好
    routes
})

export default router
